import React, { useState } from 'react';
import BulkPurchaseCard from './sections/Cards';
import TabbedProductTable from './sections/TabbedProductTable';
import AddProductModal from './sections/modals/AddProductModal';
import ViewProductModal from './sections/modals/ViewProductModal';
import EditProductModal from './sections/modals/EditProductModal';
import { useProductData } from './hooks/useProductData';
import DeleteProductModal from './sections/modals/DeleteProductModal';
import { useDeleteProductMutation, useGetSidesQuery } from '@/services/api/product/productApi';
import { message } from 'antd';

/**
 * Bulk Purchase Products Page
 * Displays product statistics and tabbed table for bulk purchase management
 */
const BulkPurchaseProducts = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [modalProps, setModalProps] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  useGetSidesQuery();
  
  // Get product type based on active tab
  const getProductType = () => {
    switch (activeTab) {
      case 0: return 'Product';      // Products tab
      case 1: return 'Platter';      // Platter tab
      case 2: return 'Non-edibles';  // Non-edibles tab
      default: return 'Product';
    }
  };

   const { foodProducts, categoryIds } = useProductData(activeTab);
  const [deleteProduct, { isLoading: deleteProductLoading }] = useDeleteProductMutation();

  // Handle modal actions
  const handleAddProduct = (modalProps = {}) => {
    setIsAddModalVisible(true);
    setModalProps(modalProps);
  };

  const handleAddModalCancel = () => {
    setIsAddModalVisible(false);
  };

  const handleAddModalSuccess = () => {
    // Refresh data or show success message
    console.log(`${getProductType()} added successfully!`);
  };

  const handleEditProduct = (record) => {
    setSelectedProduct(record.id);
    setIsEditModalVisible(true);
  };
  const handleOpenDeleteModal = (record) => {
    setSelectedProduct(record);
    setIsDeleteModal(true);
  };
  const handleDeleteProduct = async(id) => {
    // debugger
    try {
      await deleteProduct(id).unwrap();
      message.success('Product deleted successfully!');
      handleCloseDeleteModal();
    } catch (error) {
      console.error('Error deleting product:', error);
      message.error(error?.data?.message || 'Failed to delete product');
    }

  }

  

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedProduct(null);
  };
  const handleCloseDeleteModal = () => {
    setIsDeleteModal(false);
    setSelectedProduct(null);
  };

  const handleEditSuccess = () => {
    // Product was updated successfully, table will auto-refresh
    console.log('Product updated successfully');
  };

  const handleViewProduct = (record) => {
    setSelectedProduct(record.id);
    setIsViewModalVisible(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalVisible(false);
    setSelectedProduct(null);
  };

  const handleBulkPurchase = () => {
    console.log('Bulk purchase clicked');
    // TODO: Implement bulk purchase functionality
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <div className='flex flex-col gap-6'>
          {/* Product Statistics Cards */}
          <BulkPurchaseCard activeTab={activeTab} />
          
          {/* Tabbed Product Table */}
          <TabbedProductTable
            activeTab={activeTab}
            onTabChange={setActiveTab}
            onAddProduct={handleAddProduct}
            onEditProduct={handleEditProduct}
            onViewProduct={handleViewProduct}
            onDeleteProduct={handleOpenDeleteModal}
            onBulkPurchase={handleBulkPurchase}
          />
        </div>
      </div>

      {/* Add Product Modal */}
      <AddProductModal
        visible={isAddModalVisible}
        onCancel={handleAddModalCancel}
        onSuccess={handleAddModalSuccess}
        productType={modalProps.productType || getProductType()}
        categoryId={modalProps.categoryId}
      />

      {/* View Product Modal */}
      <ViewProductModal
        visible={isViewModalVisible}
        onCancel={handleCloseViewModal}
        productId={selectedProduct}
      />

      {/* Edit Product Modal */}
      <EditProductModal
        visible={isEditModalVisible}
        onCancel={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        productId={selectedProduct}
      />

      {/* Delete Product Modal */}
      <DeleteProductModal
        isOpen={isDeleteModal}
        handleClose={handleCloseDeleteModal}
        product={selectedProduct}
        handleDelete={handleDeleteProduct}
        loading={deleteProductLoading}
      />
    </div>
  );
};

export default BulkPurchaseProducts;